import { AxiosError, AxiosResponse } from "axios";
import { DataType, FieldType } from "@websential/cosmic-v20";
import {
	IEarnings,
	IEarningsListPayload,
	IEarningsResponse,
} from "../models/Earnings";
import { IGetListRequest, IResponse, IServerError } from "../models/common";

import { GridSize } from "@mui/material";
import { IPayrollFederalEarnings } from "../models/PayrollFederalEarningsSetup";
import { IPayrollInsurableEarnings } from "../models/PayrollInsurableEarningsSetup";
import { IPayrollPensionableEarnings } from "../models/PayrollPensionableEarningsSetup/IPayrollPensionableEarnings";
import http from "../common/http-commons";

// import { IFixedAndMetaField } from 'common/FlexFieldsUtils';

// import { IVendorListPayload, IVendorRequest, IVendorResponse } from 'models/vendor';
// import { CLIENT_SETUP_FORM, CLIENT_SETUP_FORM_FOR_ADMIN_USER } from 'screensLayoutData/client';

// import { IAPIKeysRequest, IAPIKeysResponse } from '../models';

// import { IEarningsListPayload, IEarningsRequest, IEarningsResponse } from '../models/earnings';



// import { INITIAL_PAGE_SIZE } from 'common/constants';

export const PayrollEHTEarningService = {
	getEarnings: async (
		clientId: string,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void
	): Promise<
		IEarningsListPayload | IServerError | IResponse | IEarningsResponse[]
	> => {
		try {
			const response: AxiosResponse<IEarningsListPayload> =
				await http.get<IEarningsListPayload>(
					"/v1/payroll-eht-on-bc-earning/?order_by=" +
						data.order_by +
						"&order_direction=" +
						data.order_direction +
						"&page=" +
						data.page +
						"&size=" +
						data.size +
						"&search_query=" +
						data.search_query
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				 
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	getById: async (
		clientId: string,
		id: string | undefined,
		navigateToLogout: (path: string) => void
	): Promise<IEarnings | IServerError | IResponse | null | any> => {
		if (!id) return null;
		try {
			const response: AxiosResponse<IEarnings> = await http.get<IEarnings>(
				`/v1/payroll-eht-on-bc-earning/${id}`
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				 
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	create: async (
		requestPayload: any
	): Promise<IPayrollPensionableEarnings | IServerError | IResponse | any> => {
		if (requestPayload.id) {
		
			try {
				const response: AxiosResponse<IEarnings> = await http.put<IEarnings>(
					`/v1/payroll-eht-on-bc-earning/${requestPayload.id}/`,
					requestPayload
				);

				if (response.status === 200) {
					return response;
				} else if (response.status === 400) {
					return response.data;
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 401) {
					requestPayload.navigateToLogout("/logout");
					return {
						status: false,
						message: "UnAuthrized",
					};
				} else {
					 
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		}

		try {
			const response: AxiosResponse<IPayrollInsurableEarnings> = await http.post<IPayrollInsurableEarnings>(
				`/v1/payroll-eht-on-bc-earning/`,
				requestPayload
			);

			
			if (response.status === 201) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				 
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	delEarnings: async (
		delPayload: any
	): Promise<string | IServerError | IResponse | any> => {
		
		// return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
		try {
			const response: AxiosResponse<string> = await http.delete<string>(
				`/v1/payroll-eht-on-bc-earning/`
			);

			if (response.status === 204) {
				return "payroll eht on BC has been deleted successfully";
			} else if (response.status === 20) {
				return "payroll eht on BC has been deleted successfully";
			}  else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				delPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				 
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	delBulkEarningses: async (
		requestPayload: any
	): Promise<string | IServerError | IResponse> => {
		
		try {
			const response = await http.delete<string>(`/v1/earnings/`, {
				data: requestPayload.earningsIds,
			});
			if (response.status === 200) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				 
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	archiveEarnings: async (
		archivePayload: any
	): Promise<string | IServerError | IResponse | any> => {
		
		// return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
		try {
			const response: AxiosResponse<string> = await http.post<string>(
				`/v1/earnings/${archivePayload.earningsId}/`
			);

			if (response.status === 201) {
				return "Earnings has been archived successfully";
			} else if (response.status === 200) {
				return "Earnings has been archived successfully";
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				archivePayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				 
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
};
